import type {
    WorkOrderChangeOtherCostItem,
    WorkOrderChangeOtherCostSeasonLimitData,
    WorkOrderChangeSeasonData,
    WorkOrderOtherCostItem,
    WorkOrderOtherCostSeasonLimitData,
    WorkOrderSeasonData,
} from 'gql/graphql';
import type { AnyObject } from 'types/AnyObject';

export const getRowClass = {
    groupHeader: ({ data }: { data: AnyObject | undefined }) =>
        Boolean(data && 'nestLevel' in data && data?.nestLevel === 0),
};

export const getRowId = ({ data }: { data: AnyObject | undefined }) => String(data?.id);

export const seasonValueGetter = (
    data: WorkOrderOtherCostItem | WorkOrderChangeOtherCostItem,
    season: WorkOrderSeasonData | WorkOrderChangeSeasonData,
    key?: keyof (WorkOrderOtherCostSeasonLimitData | WorkOrderChangeOtherCostSeasonLimitData),
) => {
    if ('workOrderChangeObjects' in data) {
        const currentWOChangeLimit = data?.seasonLimits?.find((limit) => limit?.workOrderChangeSeasonId === season.id);

        return key ? currentWOChangeLimit?.[key] : currentWOChangeLimit;
    }

    const currentWOLimit = data?.seasonLimits?.find((limit) => limit?.workOrderSeasonId === season.id);

    return key ? currentWOLimit?.[key] : currentWOLimit;
};

export const getIsChildFieldDisabled = ({
    checkedIds,
    data,
}: {
    checkedIds: AnyObject;
    data: (WorkOrderOtherCostItem | WorkOrderChangeOtherCostItem) & {
        canAddOther: boolean;
        canRemoveOther: boolean;
        isIncluded: boolean;
        objectId: number;
    };
}) => {
    if (checkedIds?.[data?.objectId]) {
        return !data?.canRemoveOther && data?.isIncluded;
    }

    if (!checkedIds?.[data?.objectId]) {
        return !data?.canAddOther && !data?.isIncluded;
    }

    return false;
};
